import { render, staticRenderFns } from "./commonTable.vue?vue&type=template&id=75cbebdc&scoped=true&"
import script from "./commonTable.vue?vue&type=script&lang=js&"
export * from "./commonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cbebdc",
  null
  
)

export default component.exports